import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTicket, faBell, faCommentAlt, faCogs, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { defaultSearch } from "../../api/api";

const Topbar = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(sessionStorage.getItem('lgusr'));
  const isActive = (path) => location.pathname === path;

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (search.trim().length < 3) {
      console.log('Search query must be at least 3 characters long.');
      return;
    }

    const res = await defaultSearch(search);
    console.log(res);
  };

  const suadminItems = [
    { label: "Run Query", path: "/admin/run-query" },
    { label: "Manage Admin", path: "/admin/admin-list" },
    { label: "Notification Provider Settings", path: "/admin/notification-provider-settings" },
    { label: "Application Settings", path: "#" },
  ];

  const adminItems = [
    { label: "Org. Settings", path: "/org-settings" },
    { label: "Check List", path: "/settings/head-check-list" },
    { label: "Customer Form", path: "/admin/customer-form" },
    { label: "Customer API EndPoints", path: "/admin/customer-api-endpoint" },
    { label: "Ticket Forms", path: "/admin/ticket-forms" },
    { label: "Tickets Api EndPoints", path: "/admin/ticket-api-endpoint" },
    { label: "SMS Event Settings", path: "/admin/sms-event-settings" },
    { label: "Manage User", path: "/admin/manage-user" },
    { label: "Add User", path: "/admin/add-user" },
    { label: "Report Settings", path: "/admin/report-settings" },
  ];

  const commonItems = [
    { label: "Change Password", path: "/change-password" },
  ];

  return (
    <div className="sticky top-0 bg-blue-100 text-black z-50 shadow-lg">
      <div className="flex items-center justify-between px-4 py-2">
        {/* Left Section - Search Bar and New Ticket Button */}
        <div className="flex items-center space-x-3">
          {/* Search Bar */}
          <form onSubmit={handleSearchSubmit} className="flex items-center space-x-2">
            <input
              type="text"
              value={search}
              onChange={handleSearchChange}
              placeholder="Search..."
              className="h-8 px-3 py-1 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-400"
            />
            <button
              type="submit"
              className="h-8 bg-blue-500 text-white px-3 rounded-md hover:bg-teal-400 transition duration-300 text-sm"
            >
              Search
            </button>
          </form>
        </div>

        {/* Right Section - Notification Icons */}
        <div className="flex items-center space-x-4">
          <button title="Make Ticket"
            className={`flex items-center justify-center h-8 w-8 rounded-md ${isActive('/tickets/new-ticket') ? 'bg-teal-400' : 'bg-blue-500'
              } hover:bg-teal-400 transition duration-300`}
            onClick={() => navigate('/tickets/new-ticket')}
          >
            <FontAwesomeIcon
              icon={faTicket}
              className="text-white text-lg hover:text-white-400 transition duration-300"
            />
          </button>
          <button className="relative h-8 w-8 flex items-center justify-center" aria-label="Notifications">
            <FontAwesomeIcon
              icon={faBell}
              className="text-red-500 text-lg hover:text-red-400 transition duration-300"
            />
            <span className="absolute top-0 right-0 h-4 w-4 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
              5
            </span>
          </button>
          <button className="relative h-8 w-8 flex items-center justify-center" aria-label="Comments">
            <FontAwesomeIcon
              icon={faCommentAlt}
              className="text-orange-500 text-lg hover:text-orange-400 transition duration-300"
            />
            <span className="absolute top-0 right-0 h-4 w-4 bg-orange-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
              3
            </span>
          </button>
          <div className="relative inline-block dropdown group">
            <button className="bg-white text-gray-700 font-medium py-1 px-2 rounded-md inline-flex items-center text-sm">
              <FontAwesomeIcon icon={faCogs} className="text-gray-700 text-lg" />
              <FontAwesomeIcon icon={faChevronDown} className="text-gray-600 text-sm ml-1" />
            </button>
            {user && (
              <ul className="absolute right-0 bg-white shadow-lg rounded-lg text-gray-700 w-48 group-hover:block 
              transition-all duration-200 ease-in-out opacity-0 group-hover:opacity-100 divide-y divide-gray-300 hidden text-sm">
                {user.role === "ADMINISTRATOR" &&
                  suadminItems.map((item, index) => (
                    <li
                      key={index}
                      className="py-2 px-4 cursor-pointer whitespace-nowrap text-blue-800 hover:bg-green-500 hover:text-white transition-colors duration-200"
                      onClick={() => {
                        if (item.path !== "#") navigate(item.path);
                      }}
                    >
                      {item.label}
                    </li>
                  ))}
                {user.role === "ADMIN" &&
                  adminItems.map((item, index) => (
                    <li
                      key={index}
                      className="py-2 px-4 cursor-pointer whitespace-nowrap text-blue-800 hover:bg-green-500 hover:text-white transition-colors duration-200"
                      onClick={() => {
                        if (item.path !== "#") navigate(item.path);
                      }}
                    >
                      {item.label}
                    </li>
                  ))}
                {commonItems.map((item, index) => (
                  <li
                    key={`common-${index}`}
                    className="py-2 px-4 cursor-pointer whitespace-nowrap text-red-600 hover:bg-red-600 hover:text-white transition-colors duration-200"
                    onClick={() => {
                      if (item.path !== "#") navigate(item.path);
                    }}
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;